module.exports = __webpack_public_path__ + "static/media/logo.de63bc32.png";